export const changeLanguage = lang => ({
  type: 'CHANGE_LANGUAGE',
  lang
})

export const handleMobileSearchForm = val => ({
  type: 'HANDLE_MOBILE_SEARCH_FORM',
  val
})

export const handleMenu = val => ({
  type: 'HANDLE_MENU',
  val
})
